export type MenuItemTypes = {
  key: string;
  label: string;
  isTitle?: boolean;
  icon?: string;
  url?: string;
  badge?: {
    variant: string;
    text: string;
  };
  parentKey?: string;
  target?: string;
  children?: MenuItemTypes[];
  urlBasedOnClientCode?: boolean;
};

export const HORIZONTAL_MENU_ITEMS: MenuItemTypes[] = [
  {
    key: 'clients',
    url: '/clients',
    label: 'All clients',
    isTitle: true,
    icon: 'home',
    urlBasedOnClientCode: false,
  },
  {
    key: 'map',
    icon: 'map',
    url: '/locations/map',
    label: 'Locations map',
    isTitle: true,
    urlBasedOnClientCode: true,
  },
  {
    key: 'locations',
    icon: 'map-pin',
    url: '',
    label: 'Locations',
    isTitle: true,
    children: [],
    urlBasedOnClientCode: true,
  },
  {
    key: 'pollution-classes',
    url: '/pollution/classes',
    icon: 'bar-chart-2',
    label: 'Pollution classes',
    isTitle: true,
    urlBasedOnClientCode: true,
  },
  {
    key: 'other',
    label: 'Other',
    isTitle: true,
    icon: 'layers',
    children: [
      {
        key: 'project-presentation',
        url: '/project/presentation',
        label: 'Project presentation',
        icon: 'book',
        urlBasedOnClientCode: true,
      },
      {
        key: 'useful-links',
        url: '/useful/links',
        label: 'Useful links',
        icon: 'link',
        urlBasedOnClientCode: true,
      },
      {
        key: 'reports',
        url: '/reports',
        label: 'Reports',
        icon: 'file-text',
        urlBasedOnClientCode: true,
      },
    ],
  },
];
